/**
 * Sprint 57 (Bug #4a) + Sprint 58 · Template-Variablen fuer Mail-Antwort.
 *
 * Variablen werden im Frontend ersetzt beim Senden (LeadDetail.tsx Mail-Modal)
 * und im Template-Editor (SettingsMailTemplates.tsx) als Hilfe angezeigt.
 */

export interface TemplateVars {
  first_name: string;
  last_name: string;
  full_name: string;
  firma: string;
  uebernehmender_first_name: string;
  uebernehmender_last_name: string;
  uebernehmender_full_name: string;
}

export const TEMPLATE_VAR_HINTS: Array<{ key: keyof TemplateVars; label: string }> = [
  { key: 'first_name', label: 'Vorname des Leads' },
  { key: 'last_name', label: 'Nachname des Leads' },
  { key: 'full_name', label: 'Voller Name des Leads' },
  { key: 'firma', label: 'Firma des Leads' },
  { key: 'uebernehmender_first_name', label: 'Vorname Übernehmender' },
  { key: 'uebernehmender_last_name', label: 'Nachname Übernehmender' },
  { key: 'uebernehmender_full_name', label: 'Voller Name Übernehmender' },
];

export function leadToTemplateVars(lead: {
  name: string | null;
  firma: string | null;
  uebernehmender_name?: string | null;
}): TemplateVars {
  const splitName = (s: string | null | undefined) => {
    const parts = (s ?? '').trim().split(/\s+/).filter(Boolean);
    return {
      first: parts[0] ?? '',
      last: parts.length > 1 ? parts.slice(1).join(' ') : '',
      full: parts.join(' '),
    };
  };
  const lead_name = splitName(lead.name);
  const uebernehmender = splitName(lead.uebernehmender_name);
  return {
    first_name: lead_name.first || 'Liebe(r) Interessent(in)',
    last_name: lead_name.last,
    full_name: lead_name.full,
    firma: lead.firma ?? '',
    uebernehmender_first_name: uebernehmender.first,
    uebernehmender_last_name: uebernehmender.last,
    uebernehmender_full_name: uebernehmender.full,
  };
}

export function applyVariables(template: string, vars: TemplateVars): string {
  let out = template;
  for (const [k, v] of Object.entries(vars)) {
    out = out.replaceAll(`{${k}}`, v);
  }
  return out;
}
